import { useCallback, useSyncExternalStore } from 'react';
import { useMeCore } from '../modules/me';
import { NEW_NAVIGATION_ROLLOUT, STUDENT_VIEW_PREVIEW_KEY } from '../constants/features';

const PREVIEW_EVENT = 'student-view-preview-change';

const readPreview = () => {
  try {
    return localStorage.getItem(STUDENT_VIEW_PREVIEW_KEY) === '1';
  } catch {
    return false;
  }
};

const subscribe = (callback: () => void) => {
  window.addEventListener(PREVIEW_EVENT, callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener(PREVIEW_EVENT, callback);
    window.removeEventListener('storage', callback);
  };
};

/**
 * - enabled: el usuario ve Inicio y el selector de curso.
 * - hideNavbar: además se oculta la barra negra (alumnos, o un admin en "vista alumno").
 */
const useNewNavigation = () => {
  const { user } = useMeCore();
  const isAdmin = Boolean(user?.userRole.admin);
  const isAutomation = Boolean(user?.userRole.automation);
  const studentPreview = useSyncExternalStore(subscribe, readPreview);

  const enabled = !isAutomation && (NEW_NAVIGATION_ROLLOUT === 'all' || isAdmin);
  const hideNavbar = enabled && (!isAdmin || studentPreview);

  const setStudentPreview = useCallback((value: boolean) => {
    try {
      if (value) {
        localStorage.setItem(STUDENT_VIEW_PREVIEW_KEY, '1');
      } else {
        localStorage.removeItem(STUDENT_VIEW_PREVIEW_KEY);
      }
    } catch {
      // sin almacenamiento local la vista previa no se guarda
    }
    window.dispatchEvent(new Event(PREVIEW_EVENT));
  }, []);

  return { enabled, hideNavbar, isAdmin, studentPreview, setStudentPreview };
};

export default useNewNavigation;
